import { hexToRGBA } from '@/lib/utils/color'

export default {
  methods: {
    themeColorRGBA (hex, opacity = 1) {
      return hexToRGBA(this.$vuetify.theme.themes.light[hex], opacity)
    }
  }
}
